module.exports = __webpack_public_path__ + "static/img/erwe2.8c74530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erwe2.png
// module id = Uyox
// module chunks = 36